import { render, staticRenderFns } from "./addPollutant.vue?vue&type=template&id=22b84935&scoped=true&"
import script from "./addPollutant.vue?vue&type=script&lang=js&"
export * from "./addPollutant.vue?vue&type=script&lang=js&"
import style0 from "./addPollutant.vue?vue&type=style&index=0&id=22b84935&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b84935",
  null
  
)

export default component.exports